export default "/images/6dee7e7057cfd2c331828e26f6b04cc7.avif";